/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".es-banner[_ngcontent-%COMP%]{background:#f6fbff;border:2px solid #136da8;border-radius:5px;display:-ms-flexbox;display:flex}.es-banner-h1[_ngcontent-%COMP%]{font-size:1.3rem;line-height:1.5rem;font-weight:600;color:#ff6319;margin-bottom:1rem;font-family:Whitney-Semibold}\n/*# sourceMappingURL=road-rewards-banner.component.css.map*/"];
export { styles as styles };
